import { newFilter } from '../filter-new/scripts.js';

const programPage = (component) => {
  if (!component) {
    return;
  }

  const filterElement = component.querySelector('#new-filter');
  const filter = newFilter(filterElement);

  const filterDesktopElement = component.querySelector('#tags-filter-desktop');

  if (filterDesktopElement) {
    filterDesktopElement.addEventListener('change', (event) => {
      const tagElement = event.target.closest('input[type="checkbox"]');

      if (tagElement) {
        const { checked } = tagElement;
        const { id } = tagElement.dataset;

        filter.setOptionCheckValue(id, checked);
      }
    });

    filterDesktopElement.addEventListener('submit', (event) => {
      event.preventDefault();
    });
  }
};

const mountProgramPage = () => {
  const page = document.querySelector('#program-page');

  if (!page) {
    return;
  }

  programPage(page);
};

export default mountProgramPage;
export { programPage };
